import { render, staticRenderFns } from "./ChapterQuestion.vue?vue&type=template&id=461d47b5&scoped=true&"
import script from "./ChapterQuestion.vue?vue&type=script&lang=js&"
export * from "./ChapterQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ChapterQuestion.vue?vue&type=style&index=0&id=461d47b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461d47b5",
  null
  
)

export default component.exports